import { render, staticRenderFns } from "./SelectKeywordsModal.vue?vue&type=template&id=1c3e54f4&scoped=true"
import script from "./SelectKeywordsModal.vue?vue&type=script&lang=js"
export * from "./SelectKeywordsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectKeywordsModal.vue?vue&type=style&index=0&id=1c3e54f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e54f4",
  null
  
)

export default component.exports